import { render, staticRenderFns } from "./CompareEdit.vue?vue&type=template&id=861c816a&scoped=true&"
import script from "./CompareEdit.vue?vue&type=script&lang=js&"
export * from "./CompareEdit.vue?vue&type=script&lang=js&"
import style0 from "./CompareEdit.vue?vue&type=style&index=0&id=861c816a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861c816a",
  null
  
)

export default component.exports